import { ApprovalNode, ChannelSupplierOperationPermission, supplierTagListTags, enums } from "services/api";

export enum TABLE_COLUMNSKEYS {
    // MPC供应商ID
    id = "id",
    // MPC供应商ID
    main_supplier_id = "main_supplier_id",
    // 供应商名称
    supplier_name = 'supplier_name',
    // 供应商名称
    main_supplier_name = "main_supplier_name",
    // 简称
    main_supplier_abbr_name = "main_supplier_abbr_name",
    // 简称
    abbr_name = 'abbr_name',
    // 服务类型
    channel_type = "channel_type",
    // 是否单一来源
    single_source = "single_source",
    // 供应商类型
    type = "type",
    // 供应商类型,
    supplier_types = 'supplier_types',
    // 创建时间
    created_at = "created_at",
    // 创建时间
    create_date = 'create_date',
    // 状态
    status = "status",
    // 状态已退回，显示原因理由
    reason = 'reason',
    // 审核节点
    approval_node = "approval_node",
    // 垫支量级
    advance_scale = "advance_scale",
    // 类型生效时间
    type_valid_date = "type_valid_date",
    // 标签
    tags = "tags",
    // 操作
    operate = "operate",
}

export const storeColumnsKey = [
    TABLE_COLUMNSKEYS.main_supplier_id,
    TABLE_COLUMNSKEYS.main_supplier_name,
    TABLE_COLUMNSKEYS.main_supplier_abbr_name,
    TABLE_COLUMNSKEYS.channel_type,
    TABLE_COLUMNSKEYS.type,
    TABLE_COLUMNSKEYS.advance_scale,
    TABLE_COLUMNSKEYS.single_source,
    TABLE_COLUMNSKEYS.type_valid_date,
    TABLE_COLUMNSKEYS.tags,
    TABLE_COLUMNSKEYS.operate,
]

export const notStoredColumnsKey = [
    TABLE_COLUMNSKEYS.main_supplier_id,
    TABLE_COLUMNSKEYS.main_supplier_name,
    TABLE_COLUMNSKEYS.main_supplier_abbr_name,
    TABLE_COLUMNSKEYS.channel_type,
    TABLE_COLUMNSKEYS.single_source,
    TABLE_COLUMNSKEYS.created_at,
    TABLE_COLUMNSKEYS.status,
    TABLE_COLUMNSKEYS.approval_node,
    TABLE_COLUMNSKEYS.reason,
    TABLE_COLUMNSKEYS.operate
]

export const checkStroeColumnsKey = [
    TABLE_COLUMNSKEYS.main_supplier_id,
    TABLE_COLUMNSKEYS.supplier_name,
    TABLE_COLUMNSKEYS.abbr_name,
    TABLE_COLUMNSKEYS.channel_type,
    TABLE_COLUMNSKEYS.single_source,
    TABLE_COLUMNSKEYS.create_date,
    TABLE_COLUMNSKEYS.approval_node,
    TABLE_COLUMNSKEYS.operate
]

export const TABLE_COLUMNS = [
    {
        key: TABLE_COLUMNSKEYS.main_supplier_id,
        dataIndex: TABLE_COLUMNSKEYS.main_supplier_id,
        title: 'MPC供应商ID',
        width: 134,
        align: 'left',
    },
    {
        // 已入库供应商名称
        key: TABLE_COLUMNSKEYS.main_supplier_name,
        dataIndex: TABLE_COLUMNSKEYS.main_supplier_name,
        title: '供应商名称',
        width: 214,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.supplier_name,
        dataIndex: TABLE_COLUMNSKEYS.supplier_name,
        title: '供应商名称',
        width: 214,
        align: 'left',
    },
    {
        // 已入库简称
        key: TABLE_COLUMNSKEYS.main_supplier_abbr_name,
        dataIndex: TABLE_COLUMNSKEYS.main_supplier_abbr_name,
        title: '简称',
        width: 83,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.abbr_name,
        dataIndex: TABLE_COLUMNSKEYS.abbr_name,
        title: '简称',
        width: 83,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.channel_type,
        dataIndex: TABLE_COLUMNSKEYS.channel_type,
        title: '服务类型',
        width: 88,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.single_source,
        dataIndex: TABLE_COLUMNSKEYS.single_source,
        title: '是否单一来源',
        width: 120,
        align: 'left',
    },
    {
        // 已入库供应商类型
        key: TABLE_COLUMNSKEYS.type,
        dataIndex: TABLE_COLUMNSKEYS.type,
        title: '供应商类型',
        width: 111,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.supplier_types,
        dataIndex: TABLE_COLUMNSKEYS.supplier_types,
        title: '供应商类型',
        width: 111,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.created_at,
        dataIndex: TABLE_COLUMNSKEYS.created_at,
        title: '创建时间',
        width: 204,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.create_date,
        dataIndex: TABLE_COLUMNSKEYS.create_date,
        title: '创建时间',
        width: 204,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.status,
        dataIndex: TABLE_COLUMNSKEYS.status,
        title: '状态',
        width: 104,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.approval_node,
        dataIndex: TABLE_COLUMNSKEYS.approval_node,
        title: '审核节点',
        width: 104,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.reason,
        dataIndex: TABLE_COLUMNSKEYS.reason,
        title: '退回原因',
        width: 217,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.advance_scale,
        dataIndex: TABLE_COLUMNSKEYS.advance_scale,
        title: '垫支量级',
        width: 104,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.type_valid_date,
        dataIndex: TABLE_COLUMNSKEYS.type_valid_date,
        title: '类型生效时间',
        width: 173,
        align: 'left',
    },
    {
        key: TABLE_COLUMNSKEYS.tags,
        dataIndex: TABLE_COLUMNSKEYS.tags,
        title: "标签",
        align: 'left',
        width: 260,
    },
    {
        key: TABLE_COLUMNSKEYS.operate,
        dataIndex: TABLE_COLUMNSKEYS.operate,
        title: '操作',
        align: 'left',
        fixed: 'right',
        className: 'operate'
    },
];

export enum TypeStatus {
    EDIT = "编辑",
    DETAILS = '查看',
    CHANGETYPE = "供应商类型变更",
    ADDSUPPLIER = '新增供应商',
    IMPORTSUPPLIER = '导入供应商',
    EXPORTSUPPLIER = '导出供应商',
}

export enum ViewType {
    Stored = 'stored',
    NotStored = 'notStored',
    CheckStore = 'checkStore',
}

export const severTypeOptions = enums.ChannelTypeEnum.values()

export const advanceOptions = enums.ChannelSupplierAdvanceScaleEnum.values()

export const supplierTypeOptions = enums.ChannelSupplierTypeEnum.values()

export const channelSupplierOptions = enums.ChannelSupplierStatusEnum.values()

export function getSupplierTagListTags() {
    return supplierTagListTags({
        page_num: 1,
        page_size: 9999,
        status: 1
    })
}

// const ChannelSupplierStatus = [
//     // 有效
//     {
//         key: 'ACTIVE',
//         value: '1',
//         name: '有效',
//     },
//     // 草稿
//     {
//         key: 'DRAFT',
//         value: '2',
//         name: '草稿',
//     },
//     // 待审核
//     {
//         key: 'PENDING_REVIEW',
//         value: '3',
//         name: '待审核',
//     },
//     // 审核不通过
//     {
//         key: 'REVIEW_FAILED',
//         value: '4',
//         name: '审核不通过',
//     },
//     // 已退回
//     {
//         key: 'RETURNED',
//         value: '5',
//         name: '已退回',
//     },
//     // 其他
//     {
//         key: 'OTHER',
//         value: '6',
//         name: '其他',
//     },
//     // 已淘汰
//     {
//         key: 'ELIMINATED',
//         value: '7',
//         name: '已淘汰',
//     },
//     // 黑名单
//     {
//         key: 'BLACKLISTED',
//         value: '8',
//         name: '黑名单',
//     },
// ];

export enum ActionType {
    edit = '编辑',
    detail = '查看',
    commitReview = '提交审核',
    saveDraft = '保存草稿',
    tag = '打标',
    changType = '变更类型',
    biz_check = '商务审核',
    fin_check = '财务审核',
    single_source = '单一来源变更',
}

const actionMapPermission = {
    [ActionType.edit]: {
        permission: 'can_edit',
        status: ['1', '2', '5']
    },
    [ActionType.detail]: {
        permission: 'can_view',
        status: ['1', '2', '3', '4', '5', '6', '7', '8']
    },
    [ActionType.commitReview]: {
        permission: 'can_edit',
        status: ['2', '5']
    },
    [ActionType.saveDraft]: {
        permission: 'can_edit',
        status: ['2', '5']
    },
    [ActionType.tag]: {
        permission: 'can_tag',
        status: ['1']
    },
    [ActionType.changType]: {
        permission: 'can_change_supplier_type',
        status: ['1']
    },
    [ActionType.biz_check]: {
        permission: 'can_biz_audit',
        approval_node: ['1'],
        status: ['3']
    },
    [ActionType.fin_check]: {
        permission: 'can_fin_audit',
        approval_node: ['2'],
        status: ['3']
    },
    [ActionType.single_source]: {
        permission: 'can_set_single_source',
        status: ['1'],
        approval_node: ['1'],
    },
}

export const getActionsByDetail = ({
    status,
    permissions,
    approval_node,
}: {
    status: number | string,
    permissions: ChannelSupplierOperationPermission,
    approval_node: ApprovalNode
}) => {
    status = String(status);
    approval_node = String(approval_node);
    const actions = {};

    for (const key in actionMapPermission) {
        const action = actionMapPermission[key];
        // 服务端返回的权限控制
        if (action.permission && !permissions[action.permission]) {
            continue;
        }
        // 根据 status 过滤
        if (action.status && !action.status.includes(status)) {
            continue;
        }
        // 根据审批节点过滤
        if (action.approval_node && !action.approval_node.includes(approval_node)) {
            continue;
        }

        actions[key] = true;
    }

    return actions;
}

